import { FC } from 'react';
import { TSessionDetails } from '@api/io/session.io';
import { NextGenUiToggle } from '@components/NextGenUiToggle';
import { ProjectSelectionSessions } from '@components/ProjectSelection/ProjectSelectionSessions';
import { useSessionChildren } from '@hooks/data/useSessionChildren';
import { SessionDetailsPage } from '@routes/session-details/SessionDetailsPage';

type ProjectSelectionSessionDetailsProps = {
  sessionDetails: TSessionDetails;
};

export const ProjectSelectionSessionDetails: FC<
  ProjectSelectionSessionDetailsProps
> = ({ sessionDetails }) => {
  const sessionChildren = useSessionChildren({
    sessionId: sessionDetails.uuid,
  });

  return (
    <>
      <NextGenUiToggle isLoading={false} />
      <SessionDetailsPage sessionDetails={sessionDetails}>
        <ProjectSelectionSessions
          data={sessionChildren.data}
          isLoading={sessionChildren.isLoading}
          error={sessionChildren.error}
        />
      </SessionDetailsPage>
    </>
  );
};
